import request from "@/utils/request";


// 查询做题记录/pc/check/online/ExamRecordList
export const ExamRecordList = (params) => {
    return request({
        url: '/pc/check/online/ExamRecordList',
        method: 'get',
        params: {
            majorIds: params.majorIds.join(',')
        }
    })
}

// pc端查询我的证书/pc/check/online/CertificateImgPc
export const CertificateImgPc = (params) => {
    return request({
        url: '/pc/check/online/CertificateImgPc',
        method: 'get',
        params: {
            majorIds: params.majorIds.join(',')
        }
    })
}

// 获取轮播图列表
export const getPictureList = () => {
    return request({
      url: '/tcOfficialWeb/api/getCarouselList',
      method: 'get'
    })
}